import LogoutIcon from "@mui/icons-material/Logout";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  IconButton
} from "@mui/material";
import { useKeycloak } from "@react-keycloak/web";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

export interface LogoutProps {
  disabled?: boolean;
}

const Logout = ({ disabled = false }: LogoutProps) => {
  const { t } = useTranslation();

  const { keycloak } = useKeycloak();
  const [openLogoutModal, setOpenLogoutModal] = useState(false);

  const handleCloseLogoutModal = () => {
    setOpenLogoutModal(false);
  };

  const onLogout = () => {
    setOpenLogoutModal(true);
  };

  return (
    <React.Fragment>
      <Box>
        {keycloak.authenticated ? (
          <IconButton
            color="error"
            style={{ backgroundColor: "white", marginLeft: 7 }}
            onClick={onLogout}
            disabled={disabled}
          >
            <LogoutIcon />
          </IconButton>
        ) : null}
      </Box>
      <Dialog
        open={openLogoutModal}
        onClose={handleCloseLogoutModal}
        aria-labelledby="logout-dialog-title"
      >
        <DialogTitle id="logout-dialog-title">
          {t("navbar.logout.title")}
        </DialogTitle>
        <DialogActions>
          <Button onClick={handleCloseLogoutModal} variant="outlined">
            {t("navbar.logout.cancel")}
          </Button>
          <Button
            onClick={() => keycloak.logout()}
            autoFocus
            variant="contained"
            color="error"
          >
            {t("navbar.logout.confirm")}
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default Logout;
